import { Flex, Grid, View, tokens } from "@sapphire-react/core";
import type { ReactNode } from "react";
import { colors } from "../styles/colors";
import * as React from "react";

type Props = {
  children: ReactNode;
  columnGap?: number | string;
  backgroundColor?: string;
  border?: string;
  maxWidth?: number;
};

export const BaseLayout = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      columnGap = 0,
      backgroundColor = colors.sand50,
      border,
      children,
      maxWidth = 968,
    },
    ref,
  ) => (
    <Flex
      UNSAFE_style={{ boxSizing: "border-box" }}
      paddingLeft={3}
      paddingRight={3}
      width={"100%"}
      justifyContent={"center"}
      marginBottom={tokens.size.spacing5xl}
      ref={ref}
    >
      <View
        width={"100%"}
        maxWidth={{ base: 444, sm: maxWidth }}
        backgroundColor={{
          base: "initial",
          sm: backgroundColor,
        }}
        border={{
          base: "none",
          sm: border,
        }}
        borderRadius={{
          base: tokens.size.radiusMd.value,
          sm: tokens.size.radiusSm.value,
        }}
      >
        <Grid
          gridTemplateColumns={{ base: "1fr", sm: "1fr 1fr" }}
          columnGap={columnGap}
          width={"100%"}
        >
          {children}
        </Grid>
      </View>
    </Flex>
  ),
);
